// extracted by mini-css-extract-plugin
export var infoRow = "_qa-2";
export var labelContainer = "_qa-0";
export var rightInfo = "_qa-1";